import { useTranslation } from 'react-i18next';

import { Card, CardContent, Typography } from '@mui/joy';

import { DroneHeartBeat } from '../../models/DroneProfile/DroneProfile.model';

interface Props {
  heartbeat: DroneHeartBeat;
}

const InterfaceBlock = ({
  title,
  ips
}: {
  title: string;
  ips: string[];
}) => (
  <div className="border rounded p-3">
    <h4 className="font-medium mb-2">{title}</h4>
    <ul className="space-y-1 text-sm text-gray-600">
      {ips.map((ip, idx) => (
        <li key={`${title}-${idx}`}>{ip}</li>
      ))}
    </ul>
  </div>
);

export default function NetworkInterfacesCard({ heartbeat}: Props) {
  const { t } = useTranslation();
  const {
    ip_eth0,
    ip_wlan0,
    ip_docker0,
    ip_br_ce35e312a760,
    ip_veth5c573f7
  } = heartbeat;

  const items = [
    { label: t('heartbeat.network.ethernet'), data: ip_eth0 },
    { label: t('heartbeat.network.wireless'), data: ip_wlan0 },
    { label: t('heartbeat.network.docker'), data: ip_docker0 },
    { label: t('heartbeat.network.bridge'), data: ip_br_ce35e312a760 },
    { label: t('heartbeat.network.veth'), data: ip_veth5c573f7 }
  ].filter((item) => item.data && item.data.length > 0);

  if (items.length === 0) return null;

  return (
    <Card color="neutral" variant="soft">
      <CardContent>
        <Typography gutterBottom level="title-md">
          {t('heartbeat.network.title')}
        </Typography>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-3">
          {items.map(({ label, data }, idx) => (
            <InterfaceBlock ips={data!} key={idx} title={label} />
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
